import { useEffect, useState } from "react";
import CustomModal from "../../../../components/CustomModal";
import { colors } from "../../../../theme/color";

import VerifyNumOtpModal from "./VerifyNumberModal";

import {
  Label,
  TwoFactAuthLargeInput,
  TwoFactAuthPhoneBox,
  TwoFactAuthPhoneContainer,
  TwoFactAuthSmallInput,
} from "./AccountSettings.styles";
import { RootState } from "../../../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../../store/user";
interface TwoFactAuthProps {
  onClose: () => void;
  onSubmit: () => void;
}

const TwoFactAuth: React.FC<TwoFactAuthProps> = ({ onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [phone, setPhone] = useState("");
  const user = useSelector((state: RootState) => state.user?.user);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPhone = e.target.value;
    setPhone(newPhone);
    dispatch(setUserData({ ...user, phone: newPhone }));
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleSubmit = async () => {
    setOpen(false);
    onSubmit();
  };

  return (
    <>
      <div>
        <CustomModal
          open={open}
          onClose={handleClose}
          header={{
            title: "Two-Factor Authentication",
            subtitle: "Enter the 6-digit code sent to your email address ",
          }}
          submitActionText="Confirm"
          onSubmit={handleSubmit}
          btn1Bg="transparent"
          btn1Border={`1px solid ${colors.DARK_GRAY}`}
          btn1Color={colors.DARK_GRAY}
          btn2Bg={colors.GREEN}
          btn2Border={`1px solid ${colors.GREEN}`}
          btn2Color={colors.White}
          btnPadding="10px 24px"
          btnBorderRadius="10px"
        >
          <div>
            <TwoFactAuthPhoneBox>
              <Label htmlFor="countryCode">Phone Number</Label>
              <TwoFactAuthPhoneContainer>
                <TwoFactAuthSmallInput type="tel" placeholder="+1" />
                <TwoFactAuthLargeInput
                  value={phone}
                  onChange={handlePhoneChange}
                  type="number"
                  maxLength={11}
                />
              </TwoFactAuthPhoneContainer>
            </TwoFactAuthPhoneBox>
          </div>
        </CustomModal>
      </div>
    </>
  );
};

export default TwoFactAuth;
